import { combineReducers } from 'redux';
import alert from './alert';
import meta from './meta';

export default combineReducers({
  alert,
  meta,
});
